import React, { useState } from "react";
import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";

const YT_ID = "_dzewfoebTM";
const EMBED = `https://www.youtube-nocookie.com/embed/${YT_ID}?autoplay=1&rel=0&modestbranding=1&color=white&playsinline=1&iv_load_policy=3`;

const POSTER_CANDIDATES = [
  `https://i.ytimg.com/vi/${YT_ID}/maxresdefault.jpg`,
  `https://i.ytimg.com/vi/${YT_ID}/sddefault.jpg`,
  `https://i.ytimg.com/vi/${YT_ID}/hqdefault.jpg`,
];

export const VideoManifesto = ({ embedded = false }) => {
  const [playing, setPlaying] = useState(false);
  const [posterIdx, setPosterIdx] = useState(0);
  const [posterOk, setPosterOk] = useState(false);

  const player = (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="relative w-full aspect-video bg-black rounded-lg overflow-hidden border border-white/10"
    >
      {!playing ? (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          data-testid={HOME.videoPlayButton}
          aria-label="Riproduci il manifesto"
          className="absolute inset-0 group cursor-pointer"
        >
          <div
            className="absolute inset-0"
            style={{
              background:
                "radial-gradient(120% 80% at 30% 30%, rgba(0,229,255,0.14) 0%, rgba(0,229,255,0) 55%), radial-gradient(120% 80% at 70% 80%, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0) 60%), #08080b",
            }}
          />
          <div
            className="absolute inset-0 opacity-[0.08]"
            style={{
              backgroundImage:
                "linear-gradient(to right, rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.5) 1px, transparent 1px)",
              backgroundSize: "40px 40px",
            }}
          />
          <span
            className="absolute inset-0 flex items-center justify-center font-display font-bold text-white/[0.04] select-none pointer-events-none"
            style={{
              fontSize: "clamp(180px, 24vw, 380px)",
              letterSpacing: "-0.05em",
            }}
          >
            LIF
          </span>
          <img
            src={POSTER_CANDIDATES[posterIdx]}
            alt=""
            aria-hidden
            loading="lazy"
            onLoad={(e) => {
              if (e.currentTarget.naturalWidth < 200) {
                if (posterIdx < POSTER_CANDIDATES.length - 1) {
                  setPosterIdx(posterIdx + 1);
                }
              } else {
                setPosterOk(true);
              }
            }}
            onError={() => {
              if (posterIdx < POSTER_CANDIDATES.length - 1) {
                setPosterIdx(posterIdx + 1);
              }
            }}
            className="absolute inset-0 w-full h-full object-cover transition-opacity duration-500"
            style={{ opacity: posterOk ? 1 : 0 }}
          />
          <div className="absolute inset-0 bg-black/45 group-hover:bg-black/30 transition-colors" />
          <div className="absolute top-5 left-5 right-5 flex items-center justify-between font-mono text-[10px] tracking-[0.24em] uppercase text-white/80">
            <span className="flex items-center gap-2">
              <span className="pulse-dot" /> Ready
            </span>
            <span>LIF · MANIFESTO 01</span>
          </div>
          <span className="absolute inset-0 flex flex-col items-center justify-center gap-5">
            <span className="relative flex items-center justify-center w-24 h-24 sm:w-28 sm:h-28 rounded-full bg-white/95 group-hover:bg-[color:var(--lif-accent)] transition-all duration-300 group-hover:scale-105">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="text-[color:var(--lif-bg)] translate-x-[3px]"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </span>
            <span className="font-mono text-[11px] tracking-[0.28em] uppercase text-white/90">
              Guarda il manifesto
            </span>
          </span>
          <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between font-mono text-[10px] tracking-[0.24em] uppercase text-white/70">
            <span>Ed. 01 · MMXXVI</span>
            <span>HD · IT</span>
          </div>
        </button>
      ) : (
        <iframe
          src={EMBED}
          title="LIF Manifesto"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 w-full h-full"
          frameBorder="0"
        />
      )}
    </motion.div>
  );

  if (embedded) return player;

  return (
    <section
      data-testid={HOME.videoBlock}
      className="section-dark border-t border-white/10 py-20 sm:py-28"
    >
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10">{player}</div>
    </section>
  );
};

export default VideoManifesto;
